// @ts-nocheck
import {
  CFG,
  DEFAULT_BINDS,
  ITEMS,
  ITEM_ORDER,
  KEYBINDS,
  KEY_TO_SLOT,
  REPORT_CATEGORIES,
  REPORT_CAT_ORDER,
  RESERVED_KEYS,
  ROBES,
  SLOT_ORDER,
  SPELLS,
  SPELLS_IN_SLOT,
  SPELL_AVAIL,
  SPELL_ORDER,
  SPELL_SCHOOLS,
  START_LOADOUT,
  UPGRADE,
  eventKeyLabel,
  hasDevRoundCheatAccount,
  isLocalDev,
  isTeammate,
  itemCost,
  keyLabelForSlot,
  rebuildKeyToSlot,
  saveKeybinds,
  spellAvail,
  spellInfo,
  spellSfx,
  spellShopDesc,
  spellShopPurchasable,
  teamColor,
} from "../data";
import {
  TAU,
  bindTabPresenceUnload,
  clamp,
  len,
  lerp,
  rand,
  rgba,
  shade,
  shrinkState,
  tabPresenceId,
  track,
} from "../util";
import {
  SPRITE_BRIM,
  armTimedProg,
  assetURL,
  bossImageByOct,
  drawArmChargeAccent,
  drawArmRangeTelegraph,
  drawEntityGroundShadow,
  drawSpellSprite,
  drawStar,
  fireballSpriteFXEnabled,
  healPodFromWire,
  makeWizardSprite,
  octIndex,
  pveBossName,
  refreshSpellSpriteDevFields,
  spellCastPopLayer,
  spellCastPopPose,
  spellSpriteAnimFrame,
  spellSpriteDevVisible,
  spellSpriteDrawSz,
  spellSpritePhaseDrawSz,
  spellSpritePhaseLife,
  spellSpritePhaseOpt,
  spellSpritePhaseReady,
  spellSpritePhaseSpec,
  spellSpriteSpec,
  updateSpellSpriteDevPanelVisibility,
  warlockImage,
  warlockImageByOct,
} from "../sprites";
import {
  AUDIO_CREDITS,
  Sound,
} from "../audio";
import {
  EMPTY_OPTS,
  Particle,
  Pillar,
  Player,
  Sigil,
  compact,
  recalcItems,
} from "../entities";
import {
  Net,
  Tip,
  angLerp,
  angleDiff,
  escapeHtml,
  fmtWhen,
  modeLabel,
  ordinal,
  setupUiButtonSounds,
  showConfirm,
  spellLabel,
  spellTipHTML,
  tipAttr,
} from "../net-ui";
import {
  lobbyInviteURL,
  parseLobbyInviteCode,
} from "../lobby";

import { Game } from "./game-base";

Game.prototype.resize = function () {
    this.W = this.canvas.width = window.innerWidth;
    this.H = this.canvas.height = window.innerHeight;
    this.cx = this.W / 2; this.cy = this.H / 2;
    // World size is fixed (single source of truth); online may inherit the
    // server's value but it's the same constant. Screen size only sets zoom.
    this.maxRadius = (this.mode === "remote" && this.maxRadiusServer) ? this.maxRadiusServer : CFG.worldRadius;
    // Render scale: fit CFG.viewRadius world units into half the shorter axis,
    // so the visible slice of the world is identical across devices.
    this.scale = (Math.min(this.W, this.H) / 2) / CFG.viewRadius;
    // Oblique camera: the ground plane is foreshortened vertically. scaleY is the
    // vertical world->screen scale; scale (scaleX) stays the horizontal one.
    this.scaleY = this.scale * CFG.viewTilt;
    if (this.state === "menu" || this.state === "matchover") this.platformRadius = this.maxRadius;
    this.makeStars();
    this.makeVoidAmbient();
    this.layoutPingMeter();
    if (typeof this.layoutDraftOverlay === "function") this.layoutDraftOverlay();
    this.syncCustomCursor();
  }

Game.prototype.makeStars = function () {
    this.stars = [];
    const n = Math.floor((this.W * this.H) / 6000);
    for (let i = 0; i < n; i++) {
      this.stars.push({ x: Math.random() * this.W, y: Math.random() * this.H,
        r: rand(0.4, 1.7), a: rand(0.2, 0.9), tw: rand(0.5, 2.5), p: rand(0, TAU) });
    }
  }

Game.prototype.hasDevRoundCheatAccess = function () {
    return isLocalDev() || hasDevRoundCheatAccount(this.account);
  }

Game.prototype.tryDevRoundCheat = function (key, e) {
    const modes = { ".": "win", ",": "loss", "-": "draw" };
    const mode = modes[key];
    if (!mode || !this.hasDevRoundCheatAccess() || this.state !== "playing" || !this.net) return false;
    if (this.keyTargetIsTextField(e.target) || this._rebind) return false;
    e.preventDefault();
    if (e.repeat) return true;
    const now = performance.now();
    const seq = this._devKeySeq || { key: null, count: 0, at: 0 };
    if (seq.key !== key || now - seq.at > 900) {
      this._devKeySeq = { key, count: 1, at: now };
      return true;
    }
    seq.count++;
    seq.at = now;
    this._devKeySeq = seq;
    if (seq.count >= 3) {
      this._devKeySeq = { key: null, count: 0, at: 0 };
      this.net.send({ t: "devcheat", mode });
    }
    return true;
  }

Game.prototype.pauseBackgroundPolls = function () {
    if (this._onlinePoll) { clearInterval(this._onlinePoll); this._onlinePoll = null; }
    if (this._presenceBeat) { clearInterval(this._presenceBeat); this._presenceBeat = null; }
  }

Game.prototype.resumeBackgroundPolls = function () {
    this.startPlayersOnlinePoll();
    this.startPresenceHeartbeat();
  }

Game.prototype.pauseTabWork = function () {
    this._loopActive = false;
    Sound.suspend();
    this.pauseBackgroundPolls();
  }

Game.prototype.resumeTabWork = function () {
    Sound.resume();
    this.resumeBackgroundPolls();
    if (this._needReconcile && this.simReady && this._lastReconcile) {
      wsimReconcile(this._lastReconcile);
      this._needReconcile = false;
    }
    this.syncMusic();
    this.last = performance.now();
    if (!this._loopActive) {
      this._loopActive = true;
      requestAnimationFrame(this._boundLoop);
    }
  }

Game.prototype.onTabVisibility = function () {
    const hidden = document.hidden;
    if (hidden === this._tabHidden) return;
    this._tabHidden = hidden;
    if (hidden) this.pauseTabWork();
    else this.resumeTabWork();
  }

Game.prototype.bindEvents = function () {
    window.addEventListener("resize", () => this.resize());
    if (!this._tabVisBound) {
      this._tabVisBound = true;
      document.addEventListener("visibilitychange", () => this.onTabVisibility());
    }

    // Capture phase — 1234/QWER action bar tooltips before wireTooltips can dismiss them.
    document.addEventListener("mousemove", (e) => {
      const mx = e.clientX, my = e.clientY;
      this.mouse.x = mx;
      this.mouse.y = my;
      this.mouse.over = true;
      this.syncCustomCursor();
      if (this.slotDrag) {
        this.onSlotDragMouseMove(e);
      } else {
        this.updateSpellBarHover(mx, my);
        if (!this.overActionBarTip(mx, my)) {
          if (this.updateStatusFxHover(mx, my) && this.barTipKey) this.clearSpellBarTip();
        } else {
          this.statusTipKey = null;
        }
      }
    }, { capture: true });

    document.addEventListener("mouseleave", () => {
      this.mouse.over = false;
      this.clearSpellBarTip();
      this.statusTipKey = null;
      this.syncCustomCursor();
    });

    document.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      if (this.onSlotDragMouseDown(e)) return;
      this.mouse.down = true;
      this.syncCustomCursor();
    }, { capture: true });
    this.canvas.addEventListener("mousedown", (e) => {
      Sound.resume();
      if (e.shiftKey) {
        const barSlot = this.spellBarSlotAt(e.clientX, e.clientY);
        if (barSlot?.spellId) return;
      }
      if (e.button === 0 && this.state === "playing" && !this.sandboxShopOpen && !this.sandboxDraftOpen) {
        const p = this.human();
        if (p && p.alive && !p.falling) {
          this.mouse.x = e.clientX;
          this.mouse.y = e.clientY;
          this._holdMoveActive = true;
          this.tickHoldMove(true);
        }
      }
    });
    this.canvas.addEventListener("contextmenu", (e) => e.preventDefault());

    window.addEventListener("mouseup", (e) => {
      if (e.button !== 0) return;
      this.mouse.x = e.clientX;
      this.mouse.y = e.clientY;
      if (this.slotDrag) this.finishSlotDrag(e);
      this.mouse.down = false;
      this._holdMoveActive = false;
      this.syncCustomCursor();
    });

    window.addEventListener("keyup", (e) => {
      if (e.key === "Shift" && this.slotDrag) this.cancelSlotDrag();
    });
    window.addEventListener("blur", () => this.cancelSlotDrag());

    window.addEventListener("keydown", (e) => {
      if ((e.key === "m" || e.key === "M") && !e.ctrlKey && !e.metaKey && !e.altKey) {
        if (this.keyTargetIsTextField(e.target) || this._rebind) return;
        e.preventDefault();
        if (e.repeat) return;
        this.toggleMasterMute();
        return;
      }
      if (e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey && (e.key === "v" || e.key === "V")) {
        if (this.keyTargetIsTextField(e.target)) return;
        e.preventDefault();
        if (e.repeat) return;
        this._voidSoundManual = !this._voidSoundManual;
        if (!this._voidSoundManual) Sound.stopVoidIndicator();
        return;
      }
      if (this.tryAlphaScheduledCheat(e)) return;
      if (this.tryDevRoundCheat(e.key, e)) return;
      if (e.key === "Tab") {
        if (
          this.keyTargetIsTextField(e.target)
          || this._rebind
          || this.panelVisible("reportCenter")
          || !this.scoreboardDockVisible()
        ) return;
        e.preventDefault();
        this.scoreboardHeld = true;
        return;
      }
      if (e.key === "Escape" && this.sandboxShopOpen) { e.preventDefault(); this.closeSandboxShop(); return; }
      if ((e.key === "b" || e.key === "B") && !e.ctrlKey && !e.metaKey && !e.altKey) {
        if (this.keyTargetIsTextField(e.target) || this._rebind) return;
        if (this.matchMode !== "sandbox" || this.state !== "playing" || this.sandboxDraftOpen) return;
        e.preventDefault();
        if (e.repeat) return;
        Sound.ui();
        this.toggleSandboxShop();
        return;
      }
      if ((e.key === "s" || e.key === "S") && !e.ctrlKey && !e.metaKey && !e.altKey) {
        if (this.keyTargetIsTextField(e.target) || this._rebind) return;
        if (this.matchMode !== "sandbox" || this.state !== "playing" || this.sandboxDraftOpen) return;
        e.preventDefault();
        if (e.repeat) return;
        Sound.ui();
        this.openSandboxDraftRound();
        return;
      }
      if (e.key === "Escape" && !e.repeat && this.handleMenuEscape()) { e.preventDefault(); return; }
      if (this.inSpectateView() && (e.key === "ArrowLeft" || e.key === "[")) {
        e.preventDefault();
        this.cycleSpectate(-1);
        return;
      }
      if (this.inSpectateView() && (e.key === "ArrowRight" || e.key === "]")) {
        e.preventDefault();
        this.cycleSpectate(1);
        return;
      }
      if (this.state !== "playing" || this.sandboxShopOpen || this.sandboxDraftOpen) return;
      if (this.keyTargetIsTextField(e.target) || this._rebind || this.panelVisible("reportCenter")) return;
      const slot = KEY_TO_SLOT[eventKeyLabel(e)];
      if (!slot) return;
      e.preventDefault();   // we own this key (also stops Space/arrow page-scroll)
      if (e.repeat) return;
      const p = this.human();
      if (!p || !p.alive || p.falling) return;
      const id = p.loadout[slot];
      if (!id) return;
      const sp = SPELLS[id];
      // cooldown / silence feedback at the cursor
      if (!this.sandboxNoCD) {
        const cd = (p.cd && p.cd[id]) || 0;
        if (cd > 0) { this.cursorHint = { id, kind: "cd", until: performance.now() + 1100 }; return; }
      }
      if (p.silence > 0) { this.cursorHint = { id, kind: "silenced", until: performance.now() + 1100 }; return; }
      if (p.freeze > 0 && (id === "teleport" || id === "thrust")) { this.cursorHint = { id, kind: "frozen", until: performance.now() + 1100 }; return; }
      const o = this.castOrigin(p);
      const aim = this.aimTowardCursor(o.x, o.y);
      const castMsg = { t: "cast", id, a: aim.a, d: aim.d };
      if (sp && sp.type === "chargebeam") {
        if (this.chargingSlot) return;
        this.chargingSlot = slot;
        this.clearMoveTarget();
        if (this.net) this.net.send(castMsg);
        return;
      }
      this.clearMoveTarget();
      if (this.net) this.net.send(castMsg);
    });
    window.addEventListener("keyup", (e) => {
      if (e.key === "Tab") {
        if (
          this.keyTargetIsTextField(e.target)
          || this._rebind
          || this.panelVisible("reportCenter")
          || !this.scoreboardDockVisible()
        ) return;
        e.preventDefault();
        this.scoreboardHeld = false;
        return;
      }
      if (this.state !== "playing" || this.sandboxShopOpen || this.sandboxDraftOpen) return;
      if (this.keyTargetIsTextField(e.target) || this._rebind || this.panelVisible("reportCenter")) return;
      const slot = KEY_TO_SLOT[eventKeyLabel(e)];
      if (!slot || this.chargingSlot !== slot) return;
      const p = this.human();
      const id = p && p.loadout[slot];
      this.chargingSlot = null;
      if (this.net && id && p) {
        const o = this.castOrigin(p);
        const aim = this.aimTowardCursor(o.x, o.y);
        this.net.send({ t: "castrelease", id, a: aim.a, d: aim.d });
      }
    });
    const sandboxShopBtn = document.getElementById("sandboxShopBtn");
    if (sandboxShopBtn) sandboxShopBtn.onclick = () => { Sound.ui(); this.toggleSandboxShop(); };
    const sandboxDraftBtn = document.getElementById("sandboxDraftBtn");
    if (sandboxDraftBtn) sandboxDraftBtn.onclick = () => { Sound.ui(); this.openSandboxDraftRound(); };
    const sandboxShopClose = document.getElementById("sandboxShopClose");
    if (sandboxShopClose) sandboxShopClose.onclick = () => { Sound.ui(); this.closeSandboxShop(); };
    const sandboxSmartPlus = document.getElementById("sandboxSmartPlus");
    const sandboxSmartMinus = document.getElementById("sandboxSmartMinus");
    if (sandboxSmartPlus) sandboxSmartPlus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ smartDelta: 1 }); };
    if (sandboxSmartMinus) sandboxSmartMinus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ smartDelta: -1 }); };
    const sandboxDumbPlus = document.getElementById("sandboxDumbPlus");
    const sandboxDumbMinus = document.getElementById("sandboxDumbMinus");
    if (sandboxDumbPlus) sandboxDumbPlus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ dumbDelta: 1 }); };
    if (sandboxDumbMinus) sandboxDumbMinus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ dumbDelta: -1 }); };
    const sandboxDummyPlus = document.getElementById("sandboxDummyPlus");
    const sandboxDummyMinus = document.getElementById("sandboxDummyMinus");
    if (sandboxDummyPlus) sandboxDummyPlus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ dummyDelta: 1 }); };
    if (sandboxDummyMinus) sandboxDummyMinus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ dummyDelta: -1 }); };
    const sandboxPlatformPlus = document.getElementById("sandboxPlatformPlus");
    const sandboxPlatformMinus = document.getElementById("sandboxPlatformMinus");
    if (sandboxPlatformPlus) sandboxPlatformPlus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ platformDelta: 1 }); };
    if (sandboxPlatformMinus) sandboxPlatformMinus.onclick = () => { Sound.ui(); this.sendSandboxCfg({ platformDelta: -1 }); };
    const sandboxStationary = document.getElementById("sandboxStationary");
    if (sandboxStationary) sandboxStationary.onchange = () => this.sendSandboxCfg({ stationary: sandboxStationary.checked });
    const sandboxNoCD = document.getElementById("sandboxNoCD");
    if (sandboxNoCD) sandboxNoCD.onchange = () => this.sendSandboxCfg({ noCd: sandboxNoCD.checked });
    // Client-only sandbox debug overlay (no server cfg involved).
    const sandboxHitboxes = document.getElementById("sandboxHitboxes");
    if (sandboxHitboxes) sandboxHitboxes.onchange = () => { Sound.ui(); this.showHitboxes = sandboxHitboxes.checked; };
    const sandboxBossSelect = document.getElementById("sandboxBossSelect");
    if (sandboxBossSelect) sandboxBossSelect.onchange = () => {
      Sound.ui();
      this.sendSandboxCfg({ boss: sandboxBossSelect.value });
      sandboxBossSelect.blur();
    };
    const sandboxBossBriefingsBtn = document.getElementById("sandboxBossBriefingsBtn");
    if (sandboxBossBriefingsBtn) sandboxBossBriefingsBtn.onclick = () => {
      Sound.ui();
      this.sendSandboxCfg({ previewBriefings: true });
    };
    const bossIntroPrevBtn = document.getElementById("bossIntroPrevBtn");
    if (bossIntroPrevBtn) bossIntroPrevBtn.onclick = () => {
      Sound.ui();
      this.stepSandboxBriefing(-1);
    };
    const bossIntroNextBtn = document.getElementById("bossIntroNextBtn");
    if (bossIntroNextBtn) bossIntroNextBtn.onclick = () => {
      Sound.ui();
      this.stepSandboxBriefing(1);
    };
    const sandboxResetPos = document.getElementById("sandboxResetPos");
    if (sandboxResetPos) sandboxResetPos.onclick = () => { Sound.ui(); this.sendSandboxCfg({ reset: "pos" }); };
    const sandboxRespawnRocks = document.getElementById("sandboxRespawnRocks");
    if (sandboxRespawnRocks) sandboxRespawnRocks.onclick = () => { Sound.ui(); this.sendSandboxCfg({ reset: "pillars" }); };
    const sandboxResetAll = document.getElementById("sandboxResetAll");
    if (sandboxResetAll) sandboxResetAll.onclick = () => { Sound.ui(); this.sendSandboxCfg({ reset: "all" }); };
    const sandboxResetStats = document.getElementById("sandboxResetStats");
    if (sandboxResetStats) sandboxResetStats.onclick = () => { Sound.ui(); this.resetSandboxSessionStats(); };
    const sandboxLeaveBtn = document.getElementById("sandboxLeaveBtn");
    if (sandboxLeaveBtn) sandboxLeaveBtn.onclick = () => { Sound.ui(); this.showMenu(); };

    if (typeof window !== "undefined" && window.__PERF_PAGE) return;
    this.setupMenuUI();
  }

Game.prototype.setupAudioUI = function ($) {
    const muteBtn = $("muteBtn");
    const panel = $("audioPanel");
    if (!muteBtn || !panel) return;

    const syncMasterMuteBtn = (btn) => {
      const m = Sound.isMuted();
      btn.textContent = m ? "🔇" : "🔊";
      btn.classList.toggle("muted", m);
      btn.setAttribute("aria-label", m ? "Audio mixer (muted)" : "Audio mixer");
    };

    const syncRow = (ch) => {
      const isMaster = ch === "master";
      const rowMuted = isMaster ? Sound.isMuted() : Sound.isChannelMuted(ch);
      const pct = isMaster ? Sound.masterVolumePct() : Sound.channelVolumePct(ch);
      const muteEl = panel.querySelector(`.audio-mute-ch[data-ch="${ch}"]`);
      const slider = panel.querySelector(`.audio-slider[data-ch="${ch}"]`);
      const pctEl = panel.querySelector(`.audio-pct[data-ch="${ch}"]`);
      if (muteEl) {
        muteEl.textContent = rowMuted ? "🔇" : "🔊";
        muteEl.classList.toggle("muted", rowMuted);
        muteEl.setAttribute("aria-label", rowMuted ? `Unmute ${ch}` : `Mute ${ch}`);
      }
      if (slider) {
        slider.value = String(pct);
        slider.disabled = rowMuted;
      }
      if (pctEl) pctEl.textContent = String(pct);
    };

    const syncAll = () => {
      syncMasterMuteBtn(muteBtn);
      syncMasterMuteBtn(panel.querySelector('.audio-mute-ch[data-ch="master"]'));
      syncRow("master");
      syncRow("music");
      syncRow("sfx");
      syncRow("ui");
    };

    syncAll();

    const setPanelOpen = (open) => {
      panel.classList.toggle("hidden", !open);
      muteBtn.classList.toggle("open", open);
      muteBtn.setAttribute("aria-expanded", open ? "true" : "false");
    };
    this._setAudioPanelOpen = setPanelOpen;
    this._syncAudioUI = syncAll;

    muteBtn.onclick = (e) => {
      e.stopPropagation();
      Sound.resume();
      if (e.shiftKey) {
        this.toggleMasterMute();
        return;
      }
      setPanelOpen(panel.classList.contains("hidden"));
    };

    panel.querySelectorAll(".audio-mute-ch").forEach(btn => {
      btn.onclick = (e) => {
        e.stopPropagation();
        Sound.resume();
        const ch = btn.dataset.ch;
        if (ch === "master") Sound.toggleMute();
        else Sound.toggleChannelMute(ch);
        syncAll();
        if (ch === "ui" || ch === "master") {
          const uiOk = !Sound.isMuted() && Sound.channelVolumePct(Sound.CH.ui) > 0 && !Sound.isChannelMuted(Sound.CH.ui);
          if (uiOk) Sound.ui();
        }
      };
    });

    panel.querySelectorAll(".audio-slider").forEach(slider => {
      const apply = () => {
        const ch = slider.dataset.ch;
        const pct = parseInt(slider.value, 10);
        if (ch === "master") Sound.setMasterVolumePct(pct);
        else Sound.setChannelVolumePct(ch, pct);
        syncAll();
      };
      slider.oninput = apply;
      slider.onchange = () => {
        apply();
        Sound.resume();
        const ch = slider.dataset.ch;
        if (ch === "ui" || ch === "master") {
          const uiOk = !Sound.isMuted() && Sound.channelVolumePct(Sound.CH.ui) > 0 && !Sound.isChannelMuted(Sound.CH.ui);
          if (uiOk) Sound.ui();
        }
      };
    });

    if (!this._audioPanelCloseBound) {
      this._audioPanelCloseBound = true;
      document.addEventListener("click", (e) => {
        const wrap = $("audioWrap");
        if (!wrap || panel.classList.contains("hidden")) return;
        if (!wrap.contains(e.target)) setPanelOpen(false);
      });
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !panel.classList.contains("hidden")) setPanelOpen(false);
      });
    }
  }

Game.prototype.toggleMasterMute = function () {
    Sound.resume();
    const m = Sound.toggleMute();
    if (this._syncAudioUI) this._syncAudioUI();
    if (!m && Sound.channelVolumePct(Sound.CH.ui) > 0 && !Sound.isChannelMuted(Sound.CH.ui)) Sound.ui();
    return m;
  }

Game.prototype.keyTargetIsTextField = function (el) {
    if (!el) return false;
    const tag = el.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
  }
